import React, { useContext, useEffect, useState } from 'react';
import {
  arrayOf, bool, func, number, shape, string
} from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { AddToCart } from '@thd-olt-component-react/add-to-cart';
import { getCartOptions, getCartReqParams } from '../../BuyboxHelper';

import '../buybox.scss';
import { bogo } from '../../../mock-data/scenarios/bogo';

const BuyboxAddToCart = ({
  alterBrowserHistory,
  disableATC,
  fulfillment,
  fulfillmentMethod,
  isAssembleItemAtStore,
  itemId,
  onATCClick,
  productAddOns = {},
  quantity,
  quantityLimitExceed,
  storeId,
  storeZip,
  zipCode
}) => {
  const { channel } = useContext(ExperienceContext);

  /**
   * bogoInfo: {
   *   bogoSelectedProduct: Product data
   *   isFreeProduct: Boolean
   * }
   */
  const [bogoInfo, setBogoInfo] = useState();
  const bogoSelectedProductOnChange = ({ output: bogoData } = {}) => {
    let newBogoInfo = null;

    if (bogoData?.bogoSelectedProduct && typeof bogoData?.isFreeProduct === 'boolean') newBogoInfo = bogoData;
    // Deprecated use bogoInfo ^^
    else if (bogoData) {
      newBogoInfo = {
        bogoSelectedProduct: bogoData,
        isFreeProduct: true,
      };
    }

    setBogoInfo(newBogoInfo);
  };
  useEffect(() => {
    window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on('buybox.bogoSelectedProduct', bogoSelectedProductOnChange);
    return () => window.LIFE_CYCLE_EVENT_BUS.lifeCycle.off('buybox.bogoSelectedProduct');
  }, []);

  const buttonText = bogoInfo?.bogoSelectedProduct?.itemId ? 'Add Both to Cart' : 'Add to Cart';
  const isSusbcribeAndSaveOpted = !!productAddOns?.subscriptions?.frequency;

  return (
    <div className="buybox__atc">
      <AddToCart
        cartOptions={getCartOptions({
          alterBrowserHistory,
          bogoInfo,
          channel,
          fulfillmentMethod,
          storeId,
          storeZip,
          zipCode
        })}
        cartReqParams={getCartReqParams({
          bogoInfo,
          fulfillment,
          fulfillmentMethod,
          isAssembleItemAtStore,
          itemId,
          quantity,
          productAddOns,
          storeId,
          storeZip,
          zipCode
        })}
        disabled={disableATC || quantityLimitExceed}
        onClick={onATCClick}
        small={false}
        showIcon
      >
        {isSusbcribeAndSaveOpted ? 'Subscribe' : buttonText }
      </AddToCart>
    </div>
  );
};

BuyboxAddToCart.propTypes = {
  alterBrowserHistory: bool,
  disableATC: bool,
  fulfillment: shape({
    type: string,
    locations: arrayOf(shape({
      isAnchor: bool,
      inventory: shape({
        quantity: number,
        isInStock: bool,
        isLimitedQuantity: bool,
        isBackordered: bool
      })
    }))
  }),
  fulfillmentMethod: string,
  isAssembleItemAtStore: bool,
  itemId: string.isRequired,
  onATCClick: func,
  productAddOns: shape({
    attachedLabor: arrayOf(shape({
      attachedLaborSku: string
    })),
    warrantyItem: shape({
      itemId: string
    })
  }),
  quantity: number,
  quantityLimitExceed: bool,
  storeId: string,
  storeZip: string,
  zipCode: string
};

BuyboxAddToCart.defaultProps = {
  alterBrowserHistory: false,
  disableATC: false,
  fulfillment: null,
  fulfillmentMethod: '',
  isAssembleItemAtStore: null,
  onATCClick: () => {},
  productAddOns: null,
  quantity: 1,
  quantityLimitExceed: false,
  storeId: null,
  storeZip: null,
  zipCode: null
};

export { BuyboxAddToCart };
